module.exports = __webpack_public_path__ + "static/media/medicine1.7ff398d3.jpg";